import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { RouterProvider } from 'react-router-dom'
import * as Sentry from '@sentry/react'
import './index.css'
import { router } from './router'
import { AuthProvider } from './auth/AuthProvider'
import { AdminProvider } from './auth/AdminProvider'
import { ImpersonationProvider } from './auth/ImpersonationProvider'

Sentry.init({
  dsn: 'https://c41c224fbea4e63ca2807135c36f6bf2@o4511385091571712.ingest.us.sentry.io/4511385116475392',
  sendDefaultPii: true,
})

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <AuthProvider>
      <AdminProvider>
        <ImpersonationProvider>
          <RouterProvider router={router} />
        </ImpersonationProvider>
      </AdminProvider>
    </AuthProvider>
  </StrictMode>,
)
